<template>
  <el-container>
    <el-header>
      <el-row align="middle">
        <el-col :span="1">
          <img :src="require('@/assets/svg/users.svg')" />
        </el-col>
        <el-col :span="23">
          <span class="title-header">Crear Menú por Perfil</span>
        </el-col>
      </el-row>
    </el-header>

    <el-main>
      <el-form
        ref="formProfile"
        :model="form"
        :rules="rules"
        label-position="top"
        label-width="auto"
      >
        <el-row :gutter="20" justify="space-between">
          <el-col :span="8">
            <el-row>
              <el-col>
                <el-form-item label="Seleccione un perfil:" prop="arpe_id">
                  <el-select filterable v-model="form.arpe_id" placeholder="">
                    <el-option
                      v-for="(option, index) in profileOptions"
                      :key="index"
                      :label="option.arpe_nombre"
                      :value="option.arpe_id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-button type="primary" @click="onsubmit">
                  Crear
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16">
            <el-form-item
              v-if="form.arpe_id"
              :label="'Por favor seleccione el menu para el perfil:'"
            >
              <el-aside style="height: 72vh">
                <Build :items="menu" />
              </el-aside>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <dialog-confirm
      ref="dialogUser"
      title="Guardar"
      description="¿Está seguro de guardar el menú para este perfil?"
      :callback="getItemsSelected"
    />
  </el-container>
</template>
<script>
  import {
    getProfiles,
    saveMenuByProfile,
    getMenuByProfile
  } from '@/api/menu_build'
  import Build from '@/components/Menu/Build.vue'
  import DialogConfirm from '@/components/dialog/DialogConfirm.vue'
  export default {
    data() {
      return {
        profiles: [],
        profileOptions: [],
        menu: [],
        selectedItems: [],
        form: {
          arpe_id: ''
        },
        rules: {
          arpe_id: [
            {
              required: true,
              message: 'Este campo es requerido.',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    components: {
      Build,
      DialogConfirm
    },
    methods: {
      getItemsSelected() {
        this.selectedItems = []

        // Función recursiva para obtener todos los elementos seleccionados
        const getSelectedItems = items => {
          return items
            .map(item => {
              if (item.selected) {
                const newItem = { ...item }
                if (item.children && item.children.length > 0) {
                  newItem.children = getSelectedItems(item.children).filter(
                    child => child.selected
                  )
                }
                return newItem
              } else if (item.children && item.children.length > 0) {
                const selectedChildren = getSelectedItems(item.children).filter(
                  child => child.selected
                )
                if (selectedChildren.length > 0) {
                  return { ...item, children: selectedChildren }
                }
              }
              return null
            })
            .filter(item => item !== null)
        }

        // Obtener todos los elementos seleccionados
        this.selectedItems.push(...getSelectedItems(this.menu))

        if (this.selectedItems.length === 0) {
          this.$message({
            message: 'No se ha seleccionado ningún elemento',
            type: 'warning'
          })
          return
        }
        this.saveMenuProfile()
      },
      onsubmit() {
        this.$refs.formProfile.validate(valid => {
          if (valid) {
            this.$refs.dialogUser.open()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      async saveMenuProfile() {
        const response = await saveMenuByProfile(
          this.selectedItems,
          this.form.arpe_id
        )
        if (response.status == 200) {
          this.$message({
            message: 'Menú guardado correctamente',
            type: 'success'
          })
        } else {
          this.$message({
            message: 'Error al guardar el menú',
            type: 'error'
          })
        }
      },
      loadMenu() {
        getMenuByProfile(this.form.arpe_id).then(async response => {
          this.menu = []
          if (response.data) {
            this.menu = response.data
          }
        })
      }
    },
    async created() {
      const profiles = await getProfiles()
      this.profileOptions = profiles.data
    },
    watch: {
      'form.arpe_id': {
        handler: function(e) {
          if (e) {
            this.loadMenu()
          }
        },
        immediate: true
      }
    }
  }
</script>
<style></style>
